import isEmpty from "../../is-empty/dropdown";

export default function(value) {
  let formattedValue = value;
  if (value && !value?.records?.length > 0) {
    formattedValue = {
      records: [...value?.value?.records],
      ...value
    };
  }
  return !isEmpty(formattedValue);
}
